const CookieService = (() => {
    let memo = {};
    const getCookie = (cname) => {
        let name = `${cname}=`
        let ca = document.cookie.split(";")
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i]
            while (c.charAt(0) === " ") c = c.substring(1)
            if (c.indexOf(name) === 0) return c.substring(name.length, c.length)
        }
        return ""
    }
    return {
      getCookie,
      getParsedCookieValue: (key) => {
        memo[key] = memo[key] ? memo[key] : getCookie(key);
        return memo[key] ? JSON.parse(memo[key]) : undefined;
      },
      setCookie: (
        cname,
        cvalue,
        exdays,
        path = "/",
        domain = false,
        hostname = window.location.hostname
      ) => {
        let d = new Date();
        d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
        let expires = "expires=" + d.toUTCString();
        let cookie = cname + "=" + cvalue + ";" + expires + ";path=" + path + ";";
        if (window.location.protocol.indexOf("https") !== -1) {
          cookie += "secure;";
        }
        if (domain) {
          cookie += "domain=" + hostname;
        }
        document.cookie = cookie;
      },
      setSessionCookie: (cname, cvalue, hostname = window.location.hostname, domain = false) => {
        const d = new Date();
        d.setTime(d.getTime() + 15 * 60 * 1000); // 15 minutes in ms
        const expires = "expires=" + d.toUTCString();
        let cookie = `${cname}=${cvalue}; ${expires}; path=/;`;
        if (window.location.protocol.indexOf("https") !== -1) {
          cookie += "secure;";
        }
        if (domain) {
          cookie += "domain=" + hostname;
        }
        document.cookie = cookie;
      },
      deleteCookie: (cname, path = "/", hostname, domain = false) => {
        let d = new Date();
        d.setTime(d.getTime() - 1 * 24 * 60 * 60 * 1000);
        let expires = "expires=" + d.toUTCString();
        let cookie = cname + "=" + "" + ";" + expires + ";path=" + path + ";";
        if (window.location.protocol.indexOf("https") !== -1) {
          cookie += "secure;";
        }
        if (domain) {
          cookie += "domain=" + hostname;
        }
        document.cookie = cookie;
      },
    };
})()
